<template>
    <div>
        <div id="wrapper">
            <template v-if="$route.query.headShow === '1'">
                <div class="header">
                    <div class="header-left" @click="goBack"><img src="@/assets/public/icon_back.png" alt=""/></div>
                    <div class="header-main">订单详情</div>
                    <div class="header-right"></div>
                </div>
            </template>
            <!-- banner区域 -->
            <div :class="['statusContent', bgName]">
                <div class="text">
                    <div class="status">{{statusText}}</div>
                    <div v-if="status === 7 || status === 6" class="refundInfo" @click="showRefundInfo">
                        <span>退款信息 &nbsp;&nbsp;</span>
                        <van-icon name="arrow"/>
                    </div>
                    <div v-if="status === 1" class="refundInfo">{{`将于${min}分钟后自动取消`}}</div>
                </div>
            </div>
            <!-- 商品信息 -->
            <div class="goodsInfo">
                <h5 class="label">商品信息</h5>

                <van-skeleton title :row="4" :loading="loading">
                    <section class="top">
                        <div class="image"><img class="img" src="@/assets/vipGoods/order/icon_kekcjjslt.png"/></div>
                        <div class="right-box">
                            <div class="goods-name">{{result.goodsName}}</div>
                            <div class="price">
                                <div style="font-weight:600;color: #666666">
                                    <span v-if="result.orderRmbAmount">¥{{result.orderRmbAmount}}</span>
                                </div>
                                <div>x 1</div>
                            </div>
                        </div>
                    </section>
                </van-skeleton>

                <section class="bottom">
                    <van-skeleton title :row="6" :loading="loading">
                        <div class="row">
                            <div class="label">支付方式</div>
                            <div class="content">
                                {{result.paymentTypeName}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="label">付款金额</div>
                            <div class="content">
                                <div style="color: #FF5050">
                                    <span v-if="result.orderRmbAmount">¥{{result.orderRmbAmount}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label">订单编号</div>
                            <div class="content">
                                {{result.orderNo}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="label">下单时间</div>
                            <div class="content">
                                {{result.orderTime}}
                            </div>
                        </div>
                        <div class="row" v-if="result.payTime">
                            <div class="label">支付时间</div>
                            <div class="content">
                                {{result.payTime}}
                            </div>
                        </div>
                        <div class="row" v-if="result.cancelTime">
                            <div class="label">取消时间</div>
                            <div class="content">
                                {{result.cancelTime}}
                            </div>
                        </div>
                    </van-skeleton>
                </section>

            </div>
            <!-- 底部按钮区 -->
            <footer class="footer" v-if="status === 1 || status === 2">
                <template v-if="status === 1">
                    <van-button class="button" type="default" :loading="payLoading" @click="pay">支付</van-button>
                    <van-button class="button" type="default" :loading="cancelLoading" @click="cancel">取消</van-button>
                </template>
            </footer>
            <!-- 弹窗 -->
            <van-action-sheet v-model="show" title="退款信息">
                <div class="dialogWrap">
                    <van-skeleton title :row="6" :loading="dialogLoading">
                        <div class="row">
                            <div class="label">退货时间</div>
                            <div class="content">
                                {{refundInfo.refundTime}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="label">退货审核</div>
                            <div class="content">
                                {{refundInfo.refundStatus | parseRefundStatus}}
                            </div>
                        </div>
                        <div class="row" v-if="refundInfo.refundStatus !== 3">
                            <div class="label">审核时间</div>
                            <div class="content">
                                {{refundInfo.auditTime}}
                            </div>
                        </div>
                        <div class="row" v-if="refundInfo.refundStatus === 1">
                            <div class="label">退款金额</div>
                            <div class="content">
                                {{refundInfo.refundAmount}}
                            </div>
                        </div>
                    </van-skeleton>
                </div>
            </van-action-sheet>
            <ctl-dialog v-model="dialogData" :loading="loading"/>
        </div>
    </div>
</template>
<script>
import { Skeleton, Button, Icon, ActionSheet, Toast } from 'vant'
import { setInterval, clearInterval } from 'timers'
import dialog from '@/components/dialog'

export default {
    components: {
        [Skeleton.name]: Skeleton,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [Toast.name]: Toast,
        ctlDialog: dialog,
        [ActionSheet.name]: ActionSheet
    },
    data () {
        return {
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            timer: null,
            overTime: '', // 截止时间
            hour: '',
            min: '',
            show: false,
            payLoading: false,
            cancelLoading: false,
            refundLoading: false,
            dialogLoading: true,
            loading: true,
            bgName: 'payment',
            statusText: '',
            status: '',
            result: {},
            userInfo: {
                name: '',
                phone: '',
                address: ''
            },
            goodsInfo: {
                name: '',
                price: '',
                num: ''
            },
            id: '',
            detailList: [],
            refundInfo: {}
        }
    },
    filters: {
        parseRefundStatus (v) {
            const data = { 1: '同意', 2: '拒绝', 3: '待审核' }
            return data[v]
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$router.back()
        },
        parseTime () {
            let currentTime = parseInt(String(new Date().getTime() / 1000)) // 当前时间 秒数
            if (currentTime >= this.overTime) { // 当前系统时间大于截止时间， 清除定时器并阻断
                clearInterval(this.timer)
                this.loading = true
                this.hour = '0'
                this.min = '1'
                this.$api.cancelOrder({ orderId: this.id, orderTYpe: 1 }).then(res => {
                    if (res.status) {
                        this.getData()
                    }
                    this.loading = false
                })
                return
            }
            this.hour = parseInt(String((this.overTime - currentTime) / 3600)) // 转成小时单位
            this.min = parseInt(String(((this.overTime - currentTime) % 3600) / 60)) || 1 // 取余后剩下的秒数就是分钟的， 再除以60就是分钟了
        },
        setStatus (status) {
            let statusType = {
                1: { text: '待付款', bg: 'payment' },
                2: { text: '待发货', bg: 'wait' },
                3: { text: '已发货', bg: 'shipped' },
                4: { text: '已完成', bg: 'completed' },
                5: { text: '已取消', bg: 'cancelled' },
                6: { text: '退款中', bg: 'refund' },
                7: { text: '已退款', bg: 'refund' },
                8: { text: '已完成', bg: 'completed' }
            }
            this.statusText = statusType[status].text
            this.bgName = statusType[status].bg
        },
        showRefundInfo () {
            this.show = true
            this.$api.getRefund({ orderId: this.id }).then(res => {
                if (res.status) {
                    res.result.auditTime = res.result.auditTime ? this.moment.formatTime(res.result.auditTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.refundTime = res.result.refundTime ? this.moment.formatTime(res.result.refundTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    this.refundInfo = res.result
                }
                this.dialogLoading = false
            })
        },
        getData () {
            this.$api.vipGoodsOrderDetail({ orderId: this.id }).then(res => {
                if (res.status) {
                    res.result.orderTime = res.result.orderTime ? this.moment.formatTime(res.result.orderTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.payTime = res.result.payTime ? this.moment.formatTime(res.result.payTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    res.result.cancelTime = res.result.cancelTime ? this.moment.formatTime(res.result.cancelTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    this.result = res.result
                    this.status = res.result.orderStatus
                    this.setStatus(this.status)

                    this.overTime = parseInt(String(new Date(res.result.orderTime.replace(/-/g, '/')).getTime() / 1000)) + 1800 // 截止时间 秒数
                    clearInterval(this.timer)
                    if (this.overTime && this.status === 1) {
                        this.parseTime()
                        this.timer = setInterval(this.parseTime, 60000)
                    }
                }
                this.loading = false
            })
        },
        // 支付回调
        payCallback (v) {
            this.$router.push({ name: 'payResult', query: { result: v, headShow: this.$route.query.headShow } })
        },
        pay () {
            let cityCode = this.$jsBridge.callBackHandler('passRegionCodeData')

            this.payLoading = true
            let apiName = (Number(this.result.goodsCode) >= 100 && Number(this.result.goodsCode) <= 299) ? this.$api.vipGoodsCheckPayOpen : this.$api.checkVipPackagePayOpen

            apiName({ orderId: this.id, cityCode: cityCode, goodsCode: this.result.goodsCode }).then(res => {
                this.payLoading = false
                if (res.status && res.code === '200') {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: this.id,
                            goodsCode: this.result.goodsCode,
                            productId: this.result.productId
                        })
                    } else {
                        this.$router.push({ name: 'pay',
                            query: {
                                payId: this.id,
                                money: this.result.orderRmbAmount,
                                type: '8',
                                goodsCode: this.result.goodsCode,
                                headShow: this.$route.query.headShow
                            }
                        })
                    }
                } else if (res.code === '801') {
                    Toast.fail(res.message)
                    this.getData()
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        cancel () {
            this.dialogData = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.dialogData.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.dialogData.visible = false
                    this.$api.vipGoodsCannelOrder({ orderId: this.id }).then(res => {
                        if (res.status) {
                            this.getData()
                        }
                        this.loading = false
                    })
                },
                title: '提示',
                content: '确定取消订单吗？'
            }
        }
    },
    created () {
        this.id = this.$route.query.id

        this.getData()

        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)
    }
}
</script>
<style lang="scss" scoped>
    .header {
        position: sticky;
        top: 0;
        z-index: 9;
        background: #ffffff;
        display: flex;
        align-items: center;
        padding: 13px 10px;
        .header-left,.header-right{
            display: flex;
            align-items: center;
            width: 100px;
            img{
                width: 24px;
            }
        }
        .header-right{
            justify-content: end;
            img+img{
                margin: 0 0 0 13px;
            }
        }
        .header-main{
            text-align: center;
            flex: 1;
            font-size: 18px;
            font-weight: 600;
            color: #333333;
        }
    }

    #wrapper {
        background: #FAFAFA;
        height: 100%;
    }

    .payment { // 待付款
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
    }

    .wait { // 待发货
        background: url('~@/assets/order/bg_to_be_shipped.png') no-repeat center;
    }

    .shipped { // 已发货
        background: url('~@/assets/order/bg_shipped.png') no-repeat center;
    }

    .completed { // 已完成
        background: url('~@/assets/order/bg_completed.png') no-repeat center;
    }

    .refund { // 退款中
        background: url('~@/assets/order/bg_refund.png') no-repeat center;
    }

    .cancelled { // 已取消
        background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
    }

    .shippedInfo {
        margin-top: 7px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
    }

    .statusContent {
        height: 100px;
        background-size: 100%;
        position: relative;

        .text {
            position: absolute;
            top: 26px;
            left: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 45px;
        }

        .status {
            font-size: 24px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
        }

        .refundInfo {
            display: flex;
            align-items: center;
            padding-top: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
        }
    }

    .userInfo {
        display: flex;
        background: white;
        min-height: 80px;
        margin-bottom: 10px;

        .leftIcon {
            position: relative;
            width: 60px;

            .icon {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 24px;
                height: 24px;
                background: url('~@/assets/public/icon_address_yellow@2x.png') no-repeat;
                background-size: 100%;
            }
        }

        .rightInfo {
            box-sizing: border-box;
            width: 306px;
            padding: 17px 0;

            .top {
                display: flex;
                align-items: center;
                padding-bottom: 4px;
            }

            .name {
                display: inline-block;
                padding-right: 10px;
                color: #333333;
                font-size: 18px;
                font-weight: 600;
            }

            .phone {
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
            }

            .address {
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                word-wrap: break-word;
            }
        }
    }

    .goodsInfo {
        background: white;
        padding: 20px 15px 45px;

        .label {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
        }

        .top {
            display: flex;
            padding: 10px 0 6px;
            align-items: center;

            .image {
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                line-height: 1;
                font-size: 0;

                img {
                    width: 100%;
                }
            }

            .right-box {
                margin-left: 15px;
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;

                .time {
                    font-size: 14px;
                    margin-top: 5px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                }

                .goods-name {
                    font-size: 15px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    word-wrap: break-word;
                }
                .goods-exam-place-name {
                    color: #333333;
                    margin-top: 8px;
                    font-size: 14px;
                    line-height: 1;
                }

                .price {
                    display: flex;
                    justify-content: space-between;
                    padding-top: 10px;
                    font-size: 14px;
                    color: #666666;
                }
            }
        }
    }

    .footer {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #eeeeee;
        background: white;
        box-sizing: border-box;
        padding: 12px 15px;

        .button {
            width: 90px;
            height: 24px;
            margin: 2px;
            line-height: 24px;
            font-size: 14px;
            border-radius: 3px;
            border: 1px solid rgba(204, 204, 204, 1);
        }
    }

    .dialogWrap {
        padding: 15px;
    }

    .row {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;

        .label {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
        }

        .content {
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
        }
    }
    .goodsMore{
        margin: 15px 0 0 0;
        .content{
            position: relative;
            margin: 20px 0;
            box-sizing: border-box;
            z-index: 9;
            width: 345px;
            padding: 0 15px;
            background: #FAFAFA;
            border-radius: 5px;
            border: 1px solid #CCCCCC;

            &::before{
                position: absolute;
                top: -9px;
                left: 20px;
                content: ' ';
                display: block;
                width: 15px;
                height: 15px;
                background: #FAFAFA;
                border-left: 1px solid #CCCCCC;
                border-top: 1px solid #CCCCCC;
                z-index: 1;
                transform: rotate(45deg);
            }
            .item{
                margin: 10px 0 0 0;
                padding: 0 0 10px 0;
                border-bottom: 1px solid #CCCCCC;
            }
            .item:last-child{
                border: 0;
            }
            .item .name{
                font-size: 15px;
                font-weight: 600;
                color: #333333;
            }
            .item .exam-room{
                margin: 3px 0 0 0;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
            }

            .item .price{
                margin: 3px 0 0 0;
                display: flex;
                justify-content: space-between;
                .left{
                    font-size: 14px;
                    color: #FF5050;
                }
                .right{
                    font-size: 14px;
                    color: #666666;
                }
            }
            .give .name{
                background: url("~@/assets/vipGoods/icon_zp.png") no-repeat left center/32px 15px;
                padding: 0 0 0 35px;
            }
        }
    }

</style>
